"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body className="bg-background">
        <div className="flex-1 flex items-center justify-center min-h-screen">
          <div className="max-w-md mx-auto px-4 py-16 text-center">
            <h1 className="font-heading text-8xl font-extrabold text-primary mb-4">
              500
            </h1>
            <h2 className="font-heading text-2xl font-bold text-foreground mb-3">
              Something went wrong
            </h2>
            <p className="font-body text-muted-foreground mb-8">
              {error.message || "An unexpected error occurred"}
            </p>
            <button
              onClick={reset}
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-heading font-bold px-8 py-4 rounded-lg transition-all duration-200 shadow-lg shadow-primary/20"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
